import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { objectIsEmpty } from '@widergy/web-utils/lib/object';
import * as FORMS from '@widergy/utilitygo-forms-web/dist/constants/fieldTypes';

import SurveyActions from 'redux/survey/actions';
import { surveyType } from 'types/surveyTypes';
import UTUserForm from 'app/components/UTUserForm';

import styles from './styles.module.scss';

const Survey = ({ survey, dispatch }) => {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (!objectIsEmpty(survey)) setOpenModal(true);
  }, [survey]);

  const handleCloseModal = () => {
    dispatch(SurveyActions.cleanSurveyForm());
    setOpenModal(false);
  };
  const fieldProps = { [FORMS.FIELD_IMAGE_LABEL]: { className: styles.imageContainer } };

  return (
    <UTUserForm
      modalStyle={{
        content: { width: '45rem', maxWidth: '95%' }
      }}
      form={survey.form}
      formType={`${survey.type}Survey`}
      surveyId={survey.survey_history_id}
      useModal
      modalIsOpen={openModal}
      handleModalClose={handleCloseModal}
      fieldTypeProps={fieldProps}
      fieldClasses={{ container: styles.formContainer }}
    />
  );
};

Survey.propTypes = {
  survey: surveyType
};

const mapStateToProps = store => ({
  survey: store.survey.surveyForm
});

export default connect(mapStateToProps)(Survey);
